module.exports = __webpack_public_path__ + "img/pumping-card4.cdbff26b.png";